import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import ReduxRecord from './reduxRecord';
import { rule } from 'instructure-validations';
import { TAKE_CHAR_LIMIT } from '@instructure/quiz-common';
import { getSessionItemById } from '../selectors/sessionItems';
export var Response = /*#__PURE__*/function (_ReduxRecord) {
  function Response() {
    _classCallCheck(this, Response);
    return _callSuper(this, Response, arguments);
  }
  _inherits(Response, _ReduxRecord);
  return _createClass(Response, [{
    key: "getItem",
    value: function getItem() {
      if (this.itemId) {
        return getSessionItemById(this.getState(), this.id).getItem();
      }
    }
  }], [{
    key: "validations",
    value: function validations() {
      return {
        userResponse: [rule('maxContent', {
          limit: TAKE_CHAR_LIMIT
        })]
      };
    }
  }]);
}(ReduxRecord({
  attempt: null,
  itemId: null,
  largeFormatResponse: null,
  position: null,
  userResponse: null,
  id: null
}));
export default Response;